(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["liora-sale-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    var saleBar = document.getElementById('liora-sale-countdown');
    if (!saleBar) return;

    var hoursElement = saleBar.querySelector('[data-sale-hours]');
    var minutesElement = saleBar.querySelector('[data-sale-minutes]');
    var secondsElement = saleBar.querySelector('[data-sale-seconds]');
    var clock = saleBar.querySelector('.liora-sale-countdown__clock');
    var endTime = Date.parse(saleBar.getAttribute('data-ends-at'));

    function formatNumber(value) {
      return String(value).padStart(2, '0');
    }

    function updateCountdown() {
      var millisecondsRemaining = endTime - Date.now();

      if (!Number.isFinite(endTime) || millisecondsRemaining <= 0) {
        saleBar.remove();
        return false;
      }

      var totalSeconds = Math.floor(millisecondsRemaining / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      hoursElement.textContent = formatNumber(hours);
      minutesElement.textContent = formatNumber(minutes);
      secondsElement.textContent = formatNumber(seconds);
      clock.setAttribute('aria-label', hours + ' hours, ' + minutes + ' minutes, and ' + seconds + ' seconds remaining');
      return true;
    }

    if (!updateCountdown()) return;

    var intervalId = window.setInterval(function () {
      if (!updateCountdown()) window.clearInterval(intervalId);
    }, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
